import { ShippingAddressType } from '~~/types/checkout/ShippingAddressType';
import { useBilling, useShipping, cartGetters } from '~/utils/ct';

export default function () {

  const { cart, load: loadCart, setCart } = useCartExtended();
  const { load: loadStore, isLoaded } = useStoreVsfExtended();
  const { load: loadShipping, shipping } = useShipping();
  const { load: loadBilling, billing } = useBilling();
  const { setShippingAddressType } = useCheckoutShipping();

  const { load: loadProductsExtraGuarantee, productsExtraGuarantee } = useProductsExtraGuaranteeStore();

  const { getStocks, stocks } = useStock('cart');
  const { lineItems } = useLineItems();
  const { user, load: loadUser, isAuthenticated } = useUserExtended();
  const { clearOrderHistory } = useMyOrders();
  const { openWebSocket } = useCartWebSocket(setCart);

  useAsyncData('load-store-load-calls', async () => {

    if (!isLoaded.value) {

      await loadStore();
    
    }

    return '';
    
  });

  onMounted(() => {

    if (!cart?.value) {

      loadCart();

    }

    if (!user?.value) {

      loadUser();
    
    }

    if (!productsExtraGuarantee.value) {

      loadProductsExtraGuarantee();
    
    }

    clearOrderHistory();
  
  });

  const cartId = computed(() => cart?.value?.id);

  const sku = computed(() => lineItems.value.map(product => cartGetters.getItemSku(product)));

  watch(cartId, (value) => {

    if (value) {

      openWebSocket(value);

      if (!stocks.value) {

        getStocks({
          sku: sku.value,
        });
      
      }

      if (!shipping.value) {

        loadShipping();
      
      }

      if (!billing.value) {

        loadBilling();
      
      }
    
    }
  
  });

  watch(isAuthenticated, async (value) => {

    if (!value) {

      await setShippingAddressType(ShippingAddressType.SAME_AS_BILLING);
    
    }
  
  });

  return {
    lineItems,
  };

}
